/**
 * Listen to native menu events from Tauri and dispatch frontend actions.
 */

import { useEffect } from "react";
import { useLocation } from "wouter";
import { isTauri } from "./usePlatform";

export function useMenuEvents() {
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!isTauri()) return;

    let unlisten: Array<() => void> = [];
    let disposed = false;

    async function setup() {
      const { listen } = await import("@tauri-apps/api/event");

      const u1 = await listen<string>("menu:navigate", (event) => {
        setLocation(event.payload);
      });

      const u2 = await listen("menu:new-project", () => {
        // Dispatch a custom DOM event that AddProjectModal can listen to
        window.dispatchEvent(new CustomEvent("factory:new-project"));
      });

      if (disposed) {
        u1();
        u2();
        return;
      }
      unlisten = [u1, u2];
    }

    setup().catch((err) => console.error("[useMenuEvents] listener setup failed:", err));

    return () => {
      disposed = true;
      unlisten.forEach((fn) => fn());
    };
  }, [setLocation]);
}
